<template>
    <el-input v-bind:value="cValue" @input="valueChange" @change="valueChange" placeholder="">
        <div slot="append">
            <el-upload :action="cUploadServer"
                       :headers="cUploadHeaders"
                       :show-file-list="false"
                       :before-upload="beforeUpload"
                       :on-error="uploadError"
                       :on-success="uploadSuccess">
                <el-button :loading="uploading" icon="el-icon-upload"></el-button>
            </el-upload>
        </div>
    </el-input>
</template>

<script>
import baseUrl from '@/base-url'

export default {
    props: {
        uploadServer: {
            type: String,
            default: null
        },
        uploadHeaders: {
            type: Object,
            default: null
        },
        value: ''
    },
    data() {
        return {
            uploading: false
        }
    },
    computed: {
        cValue() {
            return this.value
        },
        cUploadServer() {
            if (this.uploadServer) {
                return this.uploadServer
            } else {
                return baseUrl + '/admin/upload/file'
            }
        },
        cUploadHeaders() {
            if (this.uploadHeaders) {
                return this.uploadHeaders
            } else {
                return {
                    'Access-Token': this.$store.state.user.access_token
                }
            }
        }
    },
    methods: {
        beforeUpload() {
            this.uploading = true
        },
        uploadError(err, file, fileList) {
            this.uploadingSrcFile = false
            this.$message.error('文件上传失败。')
            console.log(err)
        },
        uploadSuccess(response, file, fileList) {
            this.uploading = false
            if (response.code === 0) {
                this.valueChange(response.data.url)
            } else {
                this.$message.error(response.msg)
            }
        },
        valueChange(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>

</style>
